/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ServiceAddressTypeEnum {
    RESIDENTIAL = 'Residential',
    COMMERCIAL = 'Commercial',
    MULTI_FAMILY = 'Multi_Family',
}